<script lang="ts" setup>
import { computed, ComputedRef, toRefs } from 'vue';

interface PropsInterface {
  initials?: string;
  size?: number;
  fontSize?: number;
}

const props = withDefaults(defineProps<PropsInterface>(), {
  initials: 'N/A',
  size: 25,
  fontSize: 10,
});

const { initials, size, fontSize } = toRefs(props);

const sizeToWidthAndHeight: ComputedRef = computed(
  () => `font-size: ${fontSize.value}px; height:${size.value}px; width:${size.value}px`,
);
</script>

<template>
  <span
    :style="sizeToWidthAndHeight"
    class="user-button text-white inline-flex border-none relative align-items-center justify-content-center cursor border-circle font-bold"
    v-text="initials"
  />
</template>

<style scoped lang="scss">
.user-button {
  background-color: var(--primary-color-medium);
  transition: 0.2s ease;

  &:hover {
    opacity: 0.75;
  }
}
</style>
